export class MedicalRecordsApi {
  static ENVIRONMENT_STAGES: { [key: string]: string } = {
    dev: "dev",
    production: "v1",
  };

  static getMedicalRecordsConnectorStage() {
    let stage = "v1";
    if (
      ["dev", "homolog", "localhost"].some(function (p) {
        return window.location.hostname.includes(p);
      })
    ) {
      stage = "dev";
    }
    return stage;
  }

  static getMedicalRecordUrl(preferredStage?: string | null): {
    url: string;
    stage: string;
  } {
    const stage =
      preferredStage || MedicalRecordsApi.getMedicalRecordsConnectorStage();
    return { url: "https://medical-records.feegow.com/" + stage, stage };
  }

  /**
   * Fetch data from the Doctoralia Connector API
   * @param method HTTP method
   * @param route API route
   * @param preferredStage Preferred stage to fetch data from
   */
  static async fetch(
    method: string,
    route: string,
    body?: any,
    preferredStage?: string | null
  ): Promise<any> {
    const { url: apiUrl } =
      MedicalRecordsApi.getMedicalRecordUrl(preferredStage);

    const token = sessionStorage.getItem("tk") ?? localStorage.getItem("tk");
    const requestHeaders = {
      "Content-Type": "application/json",
      ...(token ? { "x-access-token": token } : {}),
    };

    const bodyString = JSON.stringify(body);

    let queryParam = "";
    if (bodyString && method === "GET") {
      queryParam = `?${bodyString}`;
    }

    const options =
      method === "GET"
        ? { method, headers: requestHeaders }
        : { method, headers: requestHeaders, body: bodyString };

    const response = await fetch(`${apiUrl}${route}${queryParam}`, options);

    if (!response.ok) {
      throw new Error(`Fetch failed with statusCode ${response.status}`);
    }
    if (response.status === 204) {
      return {};
    }

    return await response.json();
  }
}
